const IMG = {
  rice: "https://images.unsplash.com/photo-1586201375761-83865001e31c?q=80&w=800&auto=format&fit=crop",
  spices: "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?q=80&w=800&auto=format&fit=crop",
  bazaar: "https://images.unsplash.com/photo-1509358271058-acd22cc93898?q=80&w=800&auto=format&fit=crop",
  flour: "https://images.unsplash.com/photo-1509440159596-0249088772ff?q=80&w=800&auto=format&fit=crop",
  ghee: "https://images.unsplash.com/photo-1589985270826-4b7bb135bc9d?q=80&w=800&auto=format&fit=crop",
  oil: "https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?q=80&w=800&auto=format&fit=crop",
  snacks: "https://images.unsplash.com/photo-1601050690597-df0568f70950?q=80&w=800&auto=format&fit=crop",
  tea: "https://images.unsplash.com/photo-1544787219-7f47ccb76574?q=80&w=800&auto=format&fit=crop",
  groceries: "https://images.unsplash.com/photo-1542838132-92c53300491e?q=80&w=800&auto=format&fit=crop",
};

export const HERO_IMAGE = IMG.spices;

export const CATEGORIES = [
  { id: "all", label: "All", testid: "product-category-tab-all" },
  { id: "staples", label: "Staples & Grains", testid: "product-category-tab-staples" },
  { id: "spices", label: "Spices & Masalas", testid: "product-category-tab-spices" },
  { id: "oils", label: "Oils & Ghee", testid: "product-category-tab-oils" },
  { id: "snacks", label: "Snacks & Namkeen", testid: "product-category-tab-snacks" },
  { id: "household", label: "Household", testid: "product-category-tab-household" },
  { id: "pooja", label: "Pooja & Festive", testid: "product-category-tab-pooja" },
];

export const PRODUCTS = [
  { name: "Basmati Rice", hindi: "बासमती चावल", category: "staples", price: "₹95 / kg", img: IMG.rice },
  { name: "Whole Wheat Atta", hindi: "गेहूँ आटा", category: "staples", price: "₹42 / kg", img: IMG.flour },
  { name: "Toor Dal", hindi: "तूर दाल", category: "staples", price: "₹140 / kg", img: IMG.bazaar },
  { name: "Turmeric Powder", hindi: "हल्दी पाउडर", category: "spices", price: "₹28 / 100g", img: IMG.spices },
  { name: "Garam Masala", hindi: "गरम मसाला", category: "spices", price: "₹45 / 100g", img: IMG.bazaar },
  { name: "Red Chilli Powder", hindi: "लाल मिर्च", category: "spices", price: "₹32 / 100g", img: IMG.spices },
  { name: "Mustard Oil", hindi: "सरसों तेल", category: "oils", price: "₹165 / L", img: IMG.oil },
  { name: "Desi Ghee", hindi: "देसी घी", category: "oils", price: "₹580 / L", img: IMG.ghee },
  { name: "Aloo Bhujia", hindi: "आलू भुजिया", category: "snacks", price: "₹60 / 400g", img: IMG.snacks },
  { name: "Premium Chai Patti", hindi: "चाय पत्ती", category: "snacks", price: "₹120 / 250g", img: IMG.tea },
  { name: "Home Care Essentials", hindi: "घरेलू सामान", category: "household", price: "₹99 onwards", img: IMG.groceries },
  { name: "Pooja Samagri Kit", hindi: "पूजा सामग्री", category: "pooja", price: "₹149 onwards", img: IMG.spices },
];

export const CONTACT = {
  phone: "+91 70339 75569",
  phoneHref: "tel:+917033975569",
  email: "ravishek294@gmail.com",
  emailHref: "mailto:ravishek294@gmail.com",
  whatsapp: "https://wa.me/917033975569",
  hours: "6:30 AM – 10:00 PM, Open All Days",
};
